import type { Comic } from "../types/comic";

export const comics: Comic[] = [
  {
    id: "xinghai",
    title: "星海彼端的约定",
    authorId: "linchuan",
    authorName: "林川",
    cover:
      "https://readdy.ai/api/search-image?query=Manga%20comic%20cover%20illustration%20of%20a%20young%20astronaut%20girl%20and%20a%20boy%20standing%20on%20a%20floating%20space%20station%20platform%20with%20glowing%20stars%20and%20a%20teal%20nebula%2C%20soft%20warm%20amber%20rim%20light%2C%20modern%20anime%20art%20style%2C%20clean%20simple%20gradient%20background%2C%20vivid%20colors%2C%20bold%20central%20composition%2C%20no%20text&width=600&height=800&seq=waman-cover-xinghai&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Cinematic%20anime%20scene%20of%20a%20space%20station%20window%20overlooking%20a%20teal%20nebula%20and%20distant%20planet%2C%20two%20small%20silhouettes%20looking%20out%2C%20soft%20warm%20interior%20light%2C%20modern%20anime%20art%20style%2C%20vivid%20colors%2C%20wide%20composition%2C%20no%20text&width=1600&height=900&seq=waman-banner-xinghai&orientation=landscape",
    categoryIds: ["kehuan", "lianai"],
    status: "连载中",
    latestChapter: "第12话 星海之诺",
    updatedAt: "2026-10-14",
    views: "1280万",
    rating: 9.6,
    favorite: "86万",
    featured: true,
    popularity: 98,
    tags: ["太空", "青春", "双向暗恋"],
    description:
      "在环绕木星的补给站里，孤儿出身的见习导航员苏芸遇见了从地球来的观测员陆星河。两人在一次意外的信号事故中被迫搭档，穿越失重的走廊、废弃的补给舰与被极光染色的环带。当星际航线被重新规划的公告传来，一个跨越四光年的约定被写进航行日志。这是一部关于青春、孤独与守望的太空物语。",
    chapters: [
      { id: "1", index: 1, title: "第1话 出发的那天", date: "2026-06-02" },
      { id: "2", index: 2, title: "第2话 轨道上的相遇", date: "2026-06-18" },
      { id: "3", index: 3, title: "第3话 失重的约定", date: "2026-07-04" },
      { id: "4", index: 4, title: "第4话 星尘信号", date: "2026-07-21" },
      { id: "5", index: 5, title: "第5话 沉默的补给舰", date: "2026-08-06" },
      { id: "6", index: 6, title: "第6话 双子的航线", date: "2026-08-22" },
      { id: "7", index: 7, title: "第7话 极光环带", date: "2026-09-07" },
      { id: "8", index: 8, title: "第8话 抉择之时", date: "2026-09-19" },
      { id: "9", index: 9, title: "第9话 彼端的回信", date: "2026-09-30" },
      { id: "10", index: 10, title: "第10话 穿越暗礁", date: "2026-10-06" },
      { id: "11", index: 11, title: "第11话 重逢倒计时", date: "2026-10-10" },
      { id: "12", index: 12, title: "第12话 星海之诺", date: "2026-10-14" },
    ],
  },
  {
    id: "yaohu",
    title: "妖狐夜行录",
    authorId: "sumoli",
    authorName: "苏墨离",
    cover:
      "https://readdy.ai/api/search-image?query=Manga%20comic%20cover%20illustration%20of%20an%20elegant%20nine%20tailed%20fox%20spirit%20girl%20in%20flowing%20red%20ancient%20robes%20under%20a%20full%20moon%2C%20falling%20cherry%20petals%2C%20misty%20night%20forest%2C%20modern%20anime%20art%20style%2C%20clean%20simple%20gradient%20background%2C%20vivid%20colors%2C%20bold%20central%20composition%2C%20no%20text&width=600&height=800&seq=waman-cover-yaohu&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Cinematic%20anime%20scene%20of%20an%20ancient%20moonlit%20shrine%20gate%20surrounded%20by%20mist%20and%20glowing%20lanterns%2C%20one%20lone%20figure%20in%20red%20robes%2C%20ink%20wash%20textures%2C%20modern%20anime%20art%20style%2C%20vivid%20colors%2C%20wide%20composition%2C%20no%20text&width=1600&height=900&seq=waman-banner-yaohu&orientation=landscape",
    categoryIds: ["xuanhuan", "gufeng"],
    status: "连载中",
    latestChapter: "第9话 千年灯影",
    updatedAt: "2026-10-12",
    views: "972万",
    rating: 9.4,
    favorite: "64万",
    featured: true,
    popularity: 94,
    tags: ["妖怪", "古风", "宿命"],
    description:
      "修行千年的九尾狐白绫，为了寻回被封印的名字，化为人形走入人间。她结识了执着于降妖的少年道士沈墨，两人在雨夜、灯会与荒山古庙中互相试探又彼此依靠。当尘封的往事被逐一揭开，一段人与妖之间跨越千年的因缘也随之苏醒。",
    chapters: [
      { id: "1", index: 1, title: "第1话 化形之夜", date: "2026-06-10" },
      { id: "2", index: 2, title: "第2话 雨中的道士", date: "2026-06-27" },
      { id: "3", index: 3, title: "第3话 灯会疑影", date: "2026-07-15" },
      { id: "4", index: 4, title: "第4话 无名之约", date: "2026-08-02" },
      { id: "5", index: 5, title: "第5话 荒山古庙", date: "2026-08-20" },
      { id: "6", index: 6, title: "第6话 破碎的封印", date: "2026-09-08" },
      { id: "7", index: 7, title: "第7话 前尘旧梦", date: "2026-09-24" },
      { id: "8", index: 8, title: "第8话 墨与狐", date: "2026-10-05" },
      { id: "9", index: 9, title: "第9话 千年灯影", date: "2026-10-12" },
    ],
  },
  {
    id: "lingneng",
    title: "都市灵能事务所",
    authorId: "chenyao",
    authorName: "陈曜",
    cover:
      "https://readdy.ai/api/search-image?query=Manga%20comic%20cover%20illustration%20of%20a%20stylish%20young%20man%20in%20a%20dark%20trench%20coat%20summoning%20glowing%20green%20energy%20runes%20in%20a%20rainy%20neon%20city%20street%2C%20modern%20anime%20art%20style%2C%20clean%20simple%20gradient%20background%2C%20vivid%20colors%2C%20bold%20central%20composition%2C%20no%20text&width=600&height=800&seq=waman-cover-lingneng&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Cinematic%20anime%20scene%20of%20a%20rainy%20neon%20city%20alley%20at%20night%20with%20glowing%20green%20rune%20circles%20floating%20in%20the%20air%2C%20moody%20reflections%2C%20modern%20anime%20art%20style%2C%20vivid%20colors%2C%20wide%20composition%2C%20no%20text&width=1600&height=900&seq=waman-banner-lingneng&orientation=landscape",
    categoryIds: ["xuanyi", "xuanhuan"],
    status: "连载中",
    latestChapter: "第11话 门后的世界",
    updatedAt: "2026-10-13",
    views: "1104万",
    rating: 9.5,
    favorite: "73万",
    featured: true,
    popularity: 96,
    tags: ["都市", "异能力", "悬疑"],
    description:
      "在这座看似普通的城市里，每天都有人悄悄消失。灵能事务所的年轻委托人路昭专门处理那些警方无法归档的案件：会自己移动的电梯、只在雨夜出现的门、以及寄出不存在的信件的地址。当一件与十年前旧案高度相似的委托找上门，他不得不重新面对自己尘封的过去。",
    chapters: [
      { id: "1", index: 1, title: "第1话 不存在的住户", date: "2026-06-05" },
      { id: "2", index: 2, title: "第2话 雨夜的门", date: "2026-06-22" },
      { id: "3", index: 3, title: "第3话 挂号信", date: "2026-07-09" },
      { id: "4", index: 4, title: "第4话 电梯里的十三楼", date: "2026-07-26" },
      { id: "5", index: 5, title: "第5话 旧案重提", date: "2026-08-12" },
      { id: "6", index: 6, title: "第6话 委托人", date: "2026-08-29" },
      { id: "7", index: 7, title: "第7话 镜中人", date: "2026-09-13" },
      { id: "8", index: 8, title: "第8话 交易", date: "2026-09-26" },
      { id: "9", index: 9, title: "第9话 代价", date: "2026-10-03" },
      { id: "10", index: 10, title: "第10话 事务所的夜", date: "2026-10-09" },
      { id: "11", index: 11, title: "第11话 门后的世界", date: "2026-10-13" },
    ],
  },
  {
    id: "tiandian",
    title: "甜点魔法屋",
    authorId: "xiayou",
    authorName: "夏柚",
    cover:
      "https://readdy.ai/api/search-image?query=Manga%20comic%20cover%20illustration%20of%20a%20cheerful%20girl%20baker%20holding%20a%20giant%20strawberry%20cake%20in%20a%20cozy%20pastel%20dessert%20cafe%2C%20sparkles%20and%20floating%20macarons%2C%20modern%20anime%20art%20style%2C%20clean%20simple%20gradient%20background%2C%20warm%20vivid%20colors%2C%20bold%20central%20composition%2C%20no%20text&width=600&height=800&seq=waman-cover-tiandian&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Cinematic%20anime%20scene%20of%20a%20cozy%20pastel%20dessert%20cafe%20interior%20with%20overflowing%20pastry%20display%20and%20warm%20sunlight%20through%20large%20windows%2C%20modern%20anime%20art%20style%2C%20warm%20vivid%20colors%2C%20wide%20composition%2C%20no%20text&width=1600&height=900&seq=waman-banner-tiandian&orientation=landscape",
    categoryIds: ["zhiyu", "lianai"],
    status: "连载中",
    latestChapter: "第8话 会发光的糖霜",
    updatedAt: "2026-10-11",
    views: "684万",
    rating: 9.2,
    favorite: "52万",
    featured: true,
    popularity: 88,
    tags: ["美食", "治愈", "日常"],
    description:
      "新开的小店「甜点魔法屋」有一条奇怪的规矩：只有真正需要甜点的人，才能看见门口的招牌。店主柚柚和她那只爱吃马卡龙的猫，会用一份现烤的甜点，陪客人度过他们最疲惫的那个下午。没有惊天动地的冒险，只有一点点奶油、一点点糖，和刚刚好的温柔。",
    chapters: [
      { id: "1", index: 1, title: "第1话 看得见招牌的人", date: "2026-06-14" },
      { id: "2", index: 2, title: "第2话 加班的蛋糕", date: "2026-07-01" },
      { id: "3", index: 3, title: "第3话 猫与马卡龙", date: "2026-07-18" },
      { id: "4", index: 4, title: "第4话 雨天的热可可", date: "2026-08-05" },
      { id: "5", index: 5, title: "第5话 一位老客人", date: "2026-08-23" },
      { id: "6", index: 6, title: "第6话 烤焦的第一次", date: "2026-09-11" },
      { id: "7", index: 7, title: "第7话 分店的邀请", date: "2026-09-28" },
      { id: "8", index: 8, title: "第8话 会发光的糖霜", date: "2026-10-11" },
    ],
  },
  {
    id: "jianying",
    title: "剑影江湖",
    authorId: "baiwujiu",
    authorName: "白无咎",
    cover:
      "https://readdy.ai/api/search-image?query=Manga%20comic%20cover%20illustration%20of%20a%20lone%20swordsman%20in%20white%20robes%20leaping%20across%20a%20bamboo%20forest%20with%20a%20shining%20blade%2C%20dynamic%20ink%20brush%20strokes%2C%20warm%20sunset%20glow%2C%20modern%20anime%20art%20style%2C%20clean%20simple%20gradient%20background%2C%20vivid%20colors%2C%20bold%20composition%2C%20no%20text&width=600&height=800&seq=waman-cover-jianying&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Cinematic%20anime%20scene%20of%20a%20misty%20bamboo%20grove%20at%20dawn%20with%20a%20single%20swordsman%20silhouette%20and%20drifting%20petals%2C%20ink%20wash%20textures%2C%20modern%20anime%20art%20style%2C%20vivid%20colors%2C%20wide%20composition%2C%20no%20text&width=1600&height=900&seq=waman-banner-jianying&orientation=landscape",
    categoryIds: ["rexue", "gufeng"],
    status: "已完结",
    latestChapter: "第20话 剑归山海",
    updatedAt: "2026-09-30",
    views: "1536万",
    rating: 9.7,
    favorite: "98万",
    featured: true,
    popularity: 99,
    tags: ["武侠", "热血", "复仇"],
    description:
      "少年沈无咎背着师父留下的断剑走入江湖，只为查清师门一夜灭门之谜。从落霞渡口的刀客，到雪山之巅的剑冢，他一路遇强则强，也一路失去。当最后一柄剑指向真相，他才明白：所谓江湖，从来不是快意恩仇，而是替不能说话的人，把话说完。全二十话，热血完结。",
    chapters: [
      { id: "1", index: 1, title: "第1话 断剑入江湖", date: "2026-04-02" },
      { id: "2", index: 2, title: "第2话 落霞渡口", date: "2026-04-16" },
      { id: "3", index: 3, title: "第3话 刀客的规矩", date: "2026-04-30" },
      { id: "4", index: 4, title: "第4话 三招之约", date: "2026-05-14" },
      { id: "5", index: 5, title: "第5话 血夜残卷", date: "2026-05-28" },
      { id: "6", index: 6, title: "第6话 剑冢", date: "2026-06-11" },
      { id: "7", index: 7, title: "第7话 雪山问剑", date: "2026-06-25" },
      { id: "8", index: 8, title: "第8话 故人", date: "2026-07-09" },
      { id: "9", index: 9, title: "第9话 棋局", date: "2026-07-23" },
      { id: "10", index: 10, title: "第10话 十面埋伏", date: "2026-08-06" },
      { id: "11", index: 11, title: "第11话 一诺千金", date: "2026-08-20" },
      { id: "12", index: 12, title: "第12话 灭门真相", date: "2026-09-03" },
      { id: "13", index: 13, title: "第13话 孤城", date: "2026-09-10" },
      { id: "14", index: 14, title: "第14话 最后一战（上）", date: "2026-09-17" },
      { id: "15", index: 15, title: "第15话 最后一战（下）", date: "2026-09-22" },
      { id: "16", index: 16, title: "第16话 剑归山海", date: "2026-09-30" },
    ],
  },
  {
    id: "mori",
    title: "末日拾荒者",
    authorId: "chenyao",
    authorName: "陈曜",
    cover:
      "https://readdy.ai/api/search-image?query=Manga%20comic%20cover%20illustration%20of%20a%20determined%20scavenger%20in%20a%20weathered%20gas%20mask%20walking%20through%20a%20ruined%20desert%20city%20at%20dusk%2C%20broken%20skyscrapers%20and%20dust%2C%20modern%20anime%20art%20style%2C%20clean%20simple%20gradient%20background%2C%20vivid%20orange%20colors%2C%20bold%20composition%2C%20no%20text&width=600&height=800&seq=waman-cover-mori&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Cinematic%20anime%20scene%20of%20a%20vast%20ruined%20city%20under%20an%20orange%20dust%20sky%20with%20a%20lone%20traveler%20and%20a%20small%20rover%2C%20post%20apocalyptic%20mood%2C%20modern%20anime%20art%20style%2C%20vivid%20colors%2C%20wide%20composition%2C%20no%20text&width=1600&height=900&seq=waman-banner-mori&orientation=landscape",
    categoryIds: ["kehuan", "rexue"],
    status: "连载中",
    latestChapter: "第10话 水塔之下",
    updatedAt: "2026-10-08",
    views: "846万",
    rating: 9.3,
    favorite: "58万",
    featured: false,
    popularity: 90,
    tags: ["末日", "生存", "科幻"],
    description:
      "大崩坏之后，城市只剩下锈蚀的骨架与游荡的机器。拾荒者阿刃靠回收旧世界的电池维生，直到他从废墟里挖出一台还能开机的旧收音机——里面传来一个女孩的声音，说她在水塔下，等着有人回应。为了这一句声音，他决定穿越整片死亡荒原。",
    chapters: [
      { id: "1", index: 1, title: "第1话 锈色黎明", date: "2026-06-08" },
      { id: "2", index: 2, title: "第2话 一台旧收音机", date: "2026-06-25" },
      { id: "3", index: 3, title: "第3话 荒原上的车辙", date: "2026-07-12" },
      { id: "4", index: 4, title: "第4话 会走的机器", date: "2026-07-30" },
      { id: "5", index: 5, title: "第5话 交换", date: "2026-08-16" },
      { id: "6", index: 6, title: "第6话 沙暴之夜", date: "2026-09-01" },
      { id: "7", index: 7, title: "第7话 最后的电池", date: "2026-09-15" },
      { id: "8", index: 8, title: "第8话 信号", date: "2026-09-27" },
      { id: "9", index: 9, title: "第9话 有人回话", date: "2026-10-02" },
      { id: "10", index: 10, title: "第10话 水塔之下", date: "2026-10-08" },
    ],
  },
  {
    id: "xiaoyuan",
    title: "校园青春纪事",
    authorId: "xiayou",
    authorName: "夏柚",
    cover:
      "https://readdy.ai/api/search-image?query=Manga%20comic%20cover%20illustration%20of%20two%20high%20school%20students%20in%20uniforms%20sharing%20earphones%20under%20a%20big%20tree%20on%20a%20sunny%20campus%2C%20warm%20summer%20light%2C%20modern%20anime%20art%20style%2C%20clean%20simple%20gradient%20background%2C%20fresh%20green%20vivid%20colors%2C%20bold%20composition%2C%20no%20text&width=600&height=800&seq=waman-cover-xiaoyuan&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Cinematic%20anime%20scene%20of%20a%20sunny%20school%20campus%20path%20lined%20with%20green%20trees%20and%20students%20walking%2C%20warm%20afternoon%20light%20and%20lens%20flare%2C%20modern%20anime%20art%20style%2C%20vivid%20colors%2C%20wide%20composition%2C%20no%20text&width=1600&height=900&seq=waman-banner-xiaoyuan&orientation=landscape",
    categoryIds: ["xiaoyuan", "lianai"],
    status: "连载中",
    latestChapter: "第7话 天台上的约定",
    updatedAt: "2026-10-09",
    views: "612万",
    rating: 9.1,
    favorite: "47万",
    featured: false,
    popularity: 84,
    tags: ["校园", "青春", "初恋"],
    description:
      "转学生小柚刚进校就误把广播社的学长当成老师，从此开启了一连串乌龙。社团比赛、文化祭、天台的黄昏——那些以为会一直持续下去的夏天，其实正悄悄进入倒计时。一部关于第一次心动、第一次告别，以及第一次认真对待梦想的青春纪事。",
    chapters: [
      { id: "1", index: 1, title: "第1话 认错人的第一天", date: "2026-06-20" },
      { id: "2", index: 2, title: "第2话 广播社", date: "2026-07-07" },
      { id: "3", index: 3, title: "第3话 文化祭前夜", date: "2026-07-25" },
      { id: "4", index: 4, title: "第4话 雨中的伞", date: "2026-08-11" },
      { id: "5", index: 5, title: "第5话 社团比赛", date: "2026-08-28" },
      { id: "6", index: 6, title: "第6话 暑假的补习", date: "2026-09-14" },
      { id: "7", index: 7, title: "第7话 天台上的约定", date: "2026-10-09" },
    ],
  },
  {
    id: "shanhai",
    title: "山海食堂",
    authorId: "sumoli",
    authorName: "苏墨离",
    cover:
      "https://readdy.ai/api/search-image?query=Manga%20comic%20cover%20illustration%20of%20a%20cozy%20magical%20food%20stall%20where%20mythical%20beasts%20and%20a%20chef%20share%20steaming%20noodles%2C%20lanterns%20and%20floating%20ingredients%2C%20modern%20anime%20art%20style%2C%20clean%20simple%20gradient%20background%2C%20warm%20vivid%20colors%2C%20bold%20composition%2C%20no%20text&width=600&height=800&seq=waman-cover-shanhai&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Cinematic%20anime%20scene%20of%20a%20warm%20night%20market%20food%20street%20with%20steaming%20stalls%20and%20glowing%20lanterns%2C%20distant%20mountain%20silhouettes%2C%20modern%20anime%20art%20style%2C%20warm%20vivid%20colors%2C%20wide%20composition%2C%20no%20text&width=1600&height=900&seq=waman-banner-shanhai&orientation=landscape",
    categoryIds: ["zhiyu", "xuanhuan"],
    status: "连载中",
    latestChapter: "第6话 九尾的夜宵",
    updatedAt: "2026-10-04",
    views: "528万",
    rating: 9.0,
    favorite: "39万",
    featured: false,
    popularity: 80,
    tags: ["美食", "奇幻", "日常"],
    description:
      "在山与海的交界处，有一家只在夜里开门的食堂。老板不问来历，只问你今晚想吃什么。九尾狐要一碗解忧的甜汤，山海经里的神兽排着队等一份热面。这一话，又是谁带着心事，坐到了柜台前？",
    chapters: [
      { id: "1", index: 1, title: "第1话 只开夜里", date: "2026-06-30" },
      { id: "2", index: 2, title: "第2话 第一位客人", date: "2026-07-17" },
      { id: "3", index: 3, title: "第3话 解忧甜汤", date: "2026-08-03" },
      { id: "4", index: 4, title: "第4话 排队的神兽", date: "2026-08-21" },
      { id: "5", index: 5, title: "第5话 一碗热面", date: "2026-09-19" },
      { id: "6", index: 6, title: "第6话 九尾的夜宵", date: "2026-10-04" },
    ],
  },
  {
    id: "quanwang",
    title: "拳王之路",
    authorId: "baiwujiu",
    authorName: "白无咎",
    cover:
      "https://readdy.ai/api/search-image?query=Manga%20comic%20cover%20illustration%20of%20a%20muscular%20young%20boxer%20throwing%20a%20powerful%20punch%20in%20a%20bright%20boxing%20ring%2C%20sweat%20and%20motion%20lines%2C%20modern%20anime%20art%20style%2C%20clean%20simple%20gradient%20background%2C%20vivid%20red%20and%20gold%20colors%2C%20bold%20composition%2C%20no%20text&width=600&height=800&seq=waman-cover-quanwang&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Cinematic%20anime%20scene%20inside%20a%20packed%20boxing%20arena%20under%20spotlights%20with%20two%20fighters%20facing%20off%2C%20dramatic%20atmosphere%2C%20modern%20anime%20art%20style%2C%20vivid%20colors%2C%20wide%20composition%2C%20no%20text&width=1600&height=900&seq=waman-banner-quanwang&orientation=landscape",
    categoryIds: ["rexue"],
    status: "连载中",
    latestChapter: "第9话 倒下之前",
    updatedAt: "2026-10-07",
    views: "734万",
    rating: 9.2,
    favorite: "45万",
    featured: false,
    popularity: 86,
    tags: ["体育", "热血", "成长"],
    description:
      "从街头的野拳到职业擂台，少年阿铁只有三个回合的体力，却从不肯认输。他遇到的每一个对手，都比他更强、更快、更有天赋。但他相信，只要还站着，就还有下一拳。这是一部把汗水、伤痕与尊严都放进擂台的故事。",
    chapters: [
      { id: "1", index: 1, title: "第1话 街头的三回合", date: "2026-06-12" },
      { id: "2", index: 2, title: "第2话 遇见教练", date: "2026-06-29" },
      { id: "3", index: 3, title: "第3话 第一次正式赛", date: "2026-07-16" },
      { id: "4", index: 4, title: "第4话 被打醒", date: "2026-08-02" },
      { id: "5", index: 5, title: "第5话 更强的对手", date: "2026-08-19" },
      { id: "6", index: 6, title: "第6话 一记直拳", date: "2026-09-06" },
      { id: "7", index: 7, title: "第7话 五回合", date: "2026-09-21" },
      { id: "8", index: 8, title: "第8话 决意", date: "2026-10-01" },
      { id: "9", index: 9, title: "第9话 倒下之前", date: "2026-10-07" },
    ],
  },
  {
    id: "jixie",
    title: "机械纪元",
    authorId: "linchuan",
    authorName: "林川",
    cover:
      "https://readdy.ai/api/search-image?query=Manga%20comic%20cover%20illustration%20of%20a%20giant%20humanoid%20mecha%20robot%20standing%20in%20a%20futuristic%20hangar%20with%20a%20young%20pilot%20in%20the%20cockpit%20and%20a%20glowing%20green%20power%20core%2C%20modern%20anime%20art%20style%2C%20clean%20simple%20gradient%20background%2C%20vivid%20colors%2C%20bold%20composition%2C%20no%20text&width=600&height=800&seq=waman-cover-jixie&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Cinematic%20anime%20scene%20of%20a%20massive%20mecha%20hangar%20with%20engineers%20and%20glowing%20green%20power%20cores%2C%20industrial%20scale%2C%20modern%20anime%20art%20style%2C%20vivid%20colors%2C%20wide%20composition%2C%20no%20text&width=1600&height=900&seq=waman-banner-jixie&orientation=landscape",
    categoryIds: ["kehuan", "rexue"],
    status: "连载中",
    latestChapter: "第8话 核心与心",
    updatedAt: "2026-10-05",
    views: "690万",
    rating: 9.1,
    favorite: "41万",
    featured: false,
    popularity: 82,
    tags: ["机甲", "科幻", "成长"],
    description:
      "在人类与机械共存的城市「环」中，十七岁的见习驾驶员凛被选中去启动一台从未成功激活的旧时代机甲。当钢铁与意识互相试探，机甲开始第一次主动回应她的心跳。她要证明的，从来不是机器能否战斗，而是人与机械能否彼此信任。",
    chapters: [
      { id: "1", index: 1, title: "第1话 环城", date: "2026-06-16" },
      { id: "2", index: 2, title: "第2话 沉睡的机甲", date: "2026-07-03" },
      { id: "3", index: 3, title: "第3话 第一次启动", date: "2026-07-20" },
      { id: "4", index: 4, title: "第4话 心跳同步", date: "2026-08-07" },
      { id: "5", index: 5, title: "第5话 模拟战", date: "2026-08-24" },
      { id: "6", index: 6, title: "第6话 旧时代的记忆", date: "2026-09-12" },
      { id: "7", index: 7, title: "第7话 信任", date: "2026-09-25" },
      { id: "8", index: 8, title: "第8话 核心与心", date: "2026-10-05" },
    ],
  },
];